import { Box, IconButton } from '@mui/material'
import palette from '@/palette'
import { Tooltip } from '@mui/material'
import { Block, Check } from '@mui/icons-material'

const getIcon = (value: string) => {
  return value === "allowed" ? <Check sx={{ color: palette.dark.success.main }} /> : <Block sx={{ color: palette.dark.error.main }} />;
}

const CellButton = ({ value, handleToggle }: { value: string, handleToggle: () => void }) => {
  return (
    <Tooltip title={`Toggle to ${value === "allowed" ? "restricted" : "allowed"}`}>
        <IconButton
            onClick={handleToggle}
            color={value === "allowed" ? "success" : "error"}
            size="small"
            sx={{ 
                border: '1px solid',
                borderColor: value === "allowed" ? palette.dark.success.main : palette.dark.error.main,
                backgroundColor: value === "allowed" ? 'rgba(46, 125, 50, 0.1)' : 'rgba(211, 47, 47, 0.1)',
                borderRadius: '8px',
                width: '100%',
                height: '100%',
            }}
        >
            {getIcon(value)}
        </IconButton>
    </Tooltip>
  )
}

export const getCellValue = (isEditing: boolean, value: string, handleToggle: () => void) => {
  // Handle undefined values
  const safeValue = value || "restricted";
  return isEditing ? <CellButton value={safeValue} handleToggle={handleToggle} /> : <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getIcon(safeValue)}</Box>;
}